<template>
  <fb-list-body :pager="pager"
                @handlePagerSizeChange="handlePagerSizeChange"
                @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="btn-group">
      <el-button icon="el-icon-plus" @click="handleSelectRecipe">{{ $t('lang.保存食谱') }}</el-button>
    </template>

    <template slot="search-form">
      <el-form-item class="search-form-item" :label="$t('lang.语言分类')">
        <el-select clearable v-model="searchForm.lang">
          <el-option v-for="item in supportLangList" :key="item.value" :value="item.value" :label="item.name"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.分类')">
        <el-select v-model="searchForm.recipeCategoryCode" clearable :placeholder="$t('lang.请选择')">
          <el-option v-for="i in categoryList" :key="i.recipeCategoryCode" :label="i.name" :value="i.recipeCategoryCode"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.食谱名称')">
        <el-input :placeholder="$t('lang.食谱名称')" v-model="searchForm.name"></el-input>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.食谱编号')">
        <el-input :placeholder="$t('lang.食谱编号')" v-model="searchForm.number"></el-input>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.标签')">
        <el-select v-model="searchForm.tag" clearable>
          <el-option v-for="item in recipeTagList" :key="item.recipeTagCode" :label="item.name" :value="item.name" />
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item" label="">
        <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{$t('lang.搜索')}}</el-button>
        <el-button size="mini" @click="handleReset">{{$t('lang.重置')}}</el-button>
      </el-form-item>
    </template>


    <template slot="table">
      <el-table :data="tableData" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" :label="$t('lang.序号')"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.图片')">
          <template v-slot="{row}">
            <el-image style="width: 100px; height: 100px" :src="row.photo | filterImg" />
          </template>
        </el-table-column>
        <el-table-column type="index" :label="$t('lang.分类')"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.食谱名称')"></el-table-column>
        <el-table-column prop="number" :label="$t('lang.食谱编号')"></el-table-column>
        <el-table-column prop="modifyEdition" :label="$t('lang.食谱版本号')"></el-table-column>
        <el-table-column prop="lang" :label="$t('lang.食谱语言')"></el-table-column>
        <el-table-column prop="tags" :label="$t('lang.标签')"></el-table-column>
        <el-table-column prop="lastUpdateTimeStr" :label="$t('lang.更新时间')"></el-table-column>
        <el-table-column prop="makeCount" :label="$t('lang.制作次数')"></el-table-column>
        <el-table-column prop="favoriteCount" :label="$t('lang.收藏数')"></el-table-column>
        <el-table-column prop="evaluationUserCount" :label="$t('lang.评价人数')"></el-table-column>
        <el-table-column prop="avgScore" :label="$t('lang.综合评分')">
          <template v-slot="{row}">{{row.avgScore || 0}}</template>
        </el-table-column>
        <el-table-column label="">
          <template v-slot="{row}">
            <nation-list :high-light="row.confirmLangList" :list="row.supportLangList" disabled />
          </template>
        </el-table-column>
      </el-table>
    </template>

  </fb-list-body>
</template>

<script>
import {recipeCategoryList, recipeTagList} from "../../js/common";
import NationList from "../../components/nation/NationList";

export default {
  name: "OnlineCateRecipeList",
  components: {NationList},
  data() {
    return {
      api: {
        list: this.$api.recipe.list,
        updateRefRecipe: this.$api.appOnlineCategory.batchAddRecipe,
      },
      searchForm: {},
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      categoryList: [],
      recipeTagList: []
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    },
    supportLangList() {
      return this.$store.state.supportLangList;
    }
  },
  watch: {
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();
      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();
      },
      deep: true
    }
  },
  methods: {
    handleSelectRecipe() {
      let vm = this;
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }
      let recipeCodes = this.selection.map(item => item.code).join(",");
      let params = {recipeCodes, refAppOnlineCategory: this.$route.query.code};
      this.$http.post(this.api.updateRefRecipe, this.$qs.stringify(params)).then(res => {
        if(res.data.status != 200) {
          this.$message.error(res.data.desc);
          return;
        }
        this.$message.success(res.data.desc);
        this.$router.back();
      })
    },

    handleReset() {
      for (const key in this.searchForm) {
        this.searchForm[key] = "";
      }
      this.pager.pageIndex = 1;
      this.handleSearch()
    },

    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },

    handleSearch() {
      let vm = this;
      let data = {
        brandOwnerCode: this.$store.state.userInfo['brandOwnerCode'],
        status: "released",
        ...this.searchParams
      };
      delete data.code;
      this.$http.post(this.api.list, this.$qs.stringify(data)).then((resp) => {
        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;
      })
    }
  },
  async created() {
    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
    this.categoryList = await recipeCategoryList(this);
    this.recipeTagList = await recipeTagList(this);
  }
}
</script>

<style scoped>

</style>
